
import { Component, Vue } from 'vue-property-decorator';
import TicketRepositoryInterface, {
  TicketInterface,
  TicketsSearchResultInterface,
  TicketsWSMessageInterface,
} from '@/services/QA/ticket/interfaces';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'ticketRepository',
  ],
  sockets: {
    ticketsData(msg: TicketsWSMessageInterface): void {
      this.$emit('ticketsUpdate', msg.tickets);
    },
    searchTicketsResult(msg: TicketsSearchResultInterface): void {
      this.$emit('updateTickets', msg.tickets, msg.totalItems);
    },
  },
})
export default class AllTickets extends Vue {
  private ticketRepository!: TicketRepositoryInterface;
  private tickets: TicketInterface[] = [];
  private loading: boolean = true;
  private search: string = '';
  private showReviewed: boolean = false;
  private messageReceived: boolean = false;
  private responseReceived: boolean = false;
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Reviewed', value: 'reviewed' },
    { text: 'Start Date', value: 'date' },
    { text: 'End Date', value: 'closedDate' },
    { text: 'Subject', value: 'subject' },
    { text: 'Client Name', value: 'name' },
    { text: 'Client Logged', value: 'type' },
    { text: 'Participants', value: 'agents' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private totalItems: number = 0;
  private itemsPerPage: number = 10;
  private currentPage: number = 1;
  private qaTicketsResponse: TicketInterface[] = [];

  public beforeCreate(): void {
    this.$on('ticketsUpdate', (tickets: TicketInterface[]) => {
      this.messageReceived = true;
      this.mergeTicketsData(tickets);
    });

    this.$on('updateTickets', (tickets: TicketInterface[], totalItems: number) => {
      this.totalItems = totalItems;
      this.mergeTicketsData(tickets);
      this.loading = false;
    });
  }

  public async created(): Promise<void> {
    await this.initialize();
  }

  public async initialize(): Promise<void> {
    this.tickets = [];
    this.loading = true;
    this.responseReceived = false;
    this.messageReceived = false;
    const [tickets, totalItems] = await this.ticketRepository.getAllTickets(this.currentPage, this.showReviewed);
    this.qaTicketsResponse = tickets;
    this.totalItems = totalItems;
    this.responseReceived = true;
  }

  private mergeTicketsData(ticketsData: TicketInterface[]): void {
    if (!this.responseReceived) {
      setTimeout(() => this.mergeTicketsData(ticketsData), 100);
      return;
    }

    ticketsData.forEach((ticketData, index) => {
      const qaIndex = this.qaTicketsResponse.findIndex((qaTicket) => qaTicket.id === ticketData.id);
      if (qaIndex !== -1) {
        Object.assign(ticketsData[index], this.qaTicketsResponse[qaIndex]);
      }
    });

    this.tickets = ticketsData.sort((ticketA, ticketB) =>
      new Date(ticketB.closedDate).getTime() - new Date(ticketA.closedDate).getTime());

    if (this.responseReceived) {
      this.loading = false;
    }
  }


  private async changePage(): Promise<void> {
    this.tickets = [];
    if (this.search.trim() === '') {
      await this.initialize();
      return;
    }

    await this.searchTickets();
  }

  private async reviewSwitch(): Promise<void> {
    this.currentPage = 1;
    await this.initialize();
  }

  private async searchTickets(): Promise<void> {
    this.loading = true;
    this.tickets = [];

    if (this.search.trim() === '') {
      await this.initialize();
      return;
    }

    await this.ticketRepository.searchTickets(this.search, this.currentPage);
  }
}
